var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "projects-page-outer" },
    [
      _c(
        "div",
        { attrs: { id: "admin-page" } },
        [
          _c("TheAdminPageModal"),
          _vm._v(" "),
          _c("TheNavbar"),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { id: "configurator-group" } },
            [
              _c(
                "vue-custom-scrollbar",
                { staticClass: "sidenav ap-sidenav" },
                [_c("SidebarAdminPage")],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { attrs: { id: "workspace-ap" } },
                [_c("router-view", { attrs: { name: "workspace" } })],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("Spinner", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isLoading,
            expression: "isLoading"
          }
        ]
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }